const FEEDBACK_TYPES = new Set(["general", "bug", "feature"]);

export function buildFeedbackUrl(feedbackUrl, type = "general") {
  const url = new URL(feedbackUrl);
  url.searchParams.set("type", FEEDBACK_TYPES.has(type) ? type : "general");
  return url.href;
}
